//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import quoLoginModule from "@/pages/product/quoLoginModule"
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import moment from 'moment';
import { Toast} from 'vant';
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import {commonTool} from '@/util/tool.js'
export default {
  name: 'demand',
  data () {
    return {
	  nowReleaseProdCase: null,//当前点击放大的案例对象
	  nowIndex:0,//当前点击放大的案例下标
	  showfix:false,//是否显示放大弹出层
      aaa:1,
      alzsCss: 'col-xs-4 col-sm-12 col-md-12 col-lg-12 active',
      gcjsCss: 'col-xs-4 col-sm-12 col-md-12 col-lg-12',
      societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : this.$store.getters['home/getCommonSocietyId'],//0显示平台头部按钮  1显示机构头部按钮,  //机构id
      societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : this.$store.getters['home/getCommonSocietyName'],//0显示平台头部按钮  1显示机构头部按钮,  //机构id
      logoImgUrl: (this.$route.query.logoImgUrl != undefined && this.$route.query.logoImgUrl != null && this.$route.query.logoImgUrl != '' ) ? this.$route.query.logoImgUrl : this.$store.getters['home/getSocietyLogoUrl'],
      inType: (this.$route.query.inType != null && this.$route.query.inType != '' ) ? this.$route.query.inType : 1,//从哪儿进来的   0首页点击案例进入    1搜索页点击案例进入  2机构首页进入    3需求页进入
      showTopStyle: 1,//头部显示企业名称位置的样式1
      showAi: false,
      showOrther: false,
      showBzcp: false,
      showJpxc: false,
      userInfo: this.$store.getters.getUserInfo, // 登录用户信息
      baseOpen: false,
      showMoreAssociation: false,
      prodTypeAI: false,
      prodTypeOther: false,
      toTop: false,
      moment,
      isFollow: 0,//是否关注了该企业 0否 1是
      swiperOptionThumbsF: {
        loop: false,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
				navigation: {
        	nextEl: '.swiper-button-next',
        	prevEl: '.swiper-button-prev',
        },
        on: {
          tap(event) {

          }
        }
      },
      scrollRange: 600,
      pageSizeSel: 6,
      xmpcCpalSelObj: {},
      xmgeBzjcpSelObj: {},
      jpxcShowSelObj: {},
      companyId: '',
      companyReleaseInfo: {
        companyInfo: {},
        companyReleaseDetail: {}
      },
      societyList: null,//协会名称list
      releaseProdCaseList: [],
      societyNameArr: [],
      societyNameArrMore: [],
      keyWordsArr: [],
      ccReleaseCompanySpecBos: [],
      ccReleaseCompanySpecBosMore: [],
      prodTypeArray: [],
      prodInfoList: [],
      // releaseProdCaseListAI: [],
      // releaseProdCaseListOrther: [],
      releaseBoutiquePhotoList: [],
      // 精品相册分类
      releaseBoutiquePhotoTypeList: [],
      prodInfoListBzcp: [],
      selectedProdTypeValue: '-1',
      selectedProdType: {},
      selectedProdTypeValueOrther: '-1',
      selectedProdTypeOrther: {},
      showTelPop: false,
      tab: 2,
      prodCaseListAIQueryParam: {
        companyId: null,
        selSysProdTypeId: '-1',
        selParentProdTypeId: null,
        selProdTypeId: null,
        quotedPriceType: 1,
        searchStr: '',
        page: {
          pageNum: 0,
          pageSize: 6,
          taotal: 0
        }
      },
      prodCaseListOrtherQueryParam: {
        companyId: null,
        selSysProdTypeId: '-1',
        selParentProdTypeId: null,
        selProdTypeId: null,
        quotedPriceType: 2,
        searchStr: '',
        page: {
          pageNum: 0,
          pageSize: 6,
          total: 0
        }
      },
      prodCaseListBzcpQueryParam: {
        sysProdTypeId: '-1',
        page: {
          pageNum: 0,
          pageSize: 6,
          total: 0
        }
      },
      releaseBoutiquePhotoParam: {
        companyId: null,
        classifyId: '全部',
        companyReleaseDetail: {
          jpxcShow: {
            classifyId: null,
            page: {
              pageNum: 0,
              pageSize: 6,
              total: 0
            }
          }
        }
      }
    }
  },
  components:{
    Header,
    Footer,
    Swiper,
    SwiperSlide,
    quoLoginModule
  },
  directives: {
    swiper: directive
  },
  computed:{
    swiper() {
      return this.$refs.swiperThumbsF.$swiper
    },
    swiperF() {
      return this.$refs.swiperTopF.$swiper
    }
  },
  methods:{
    show(params){
      this.aaa = params
      if(params == 1){
        this.alzsCss = 'col-xs-4 col-sm-12 col-md-12 col-lg-12 active'
        this.gcjsCss = 'col-xs-4 col-sm-12 col-md-12 col-lg-12'
      }else{
        this.alzsCss = 'col-xs-4 col-sm-12 col-md-12 col-lg-12'
        this.gcjsCss = 'col-xs-4 col-sm-12 col-md-12 col-lg-12 active'
      }
    },
    phonePassword(tel) {
      if (tel != null) {
        var reg = /^(\d{3})\d{4}(\d{4})$/
        tel = tel.replace(reg, '$1****$2')
      }
      return tel
    },
    //控制公司关键字显示,有关键字显示关键字，没有显示行业名称
    fnGetShowLeyWordArr(keywordValueArr,companyTypeName){
      let showArr = [];
      if(keywordValueArr != null && keywordValueArr.length > 0){
        return keywordValueArr;
      }else{
        showArr[showArr.length] = companyTypeName
        return showArr;
      }
    },
    fnInitProdType () {
      this.prodTypeArray = []
      this.$store.dispatch('company/queryProdTypeTreeSelect', JSON.stringify({ 'companyId': this.companyId }))
        .then(res => {
          // console.log("fnInitProdType res ===>", res)
          if (res.data.retCode == 1) {
            this.prodTypeArray = [...res.data.data]
          }
        }).catch(err => {
          console.log('fnInitProdType err ===>', err)
        })
    },
    fnGetCompanyReleaseInfoMain () {
      let that = this;
      that.xmpcCpalSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"companyId":that.companyId};
      that.xmgeBzjcpSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"companyId":that.companyId};
      that.jpxcShowSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"companyId":that.companyId};

      let param = {"companyId" : that.companyId,"societyId" : that.societyId, "companyReleaseDetail" : {"xmpcCpal": that.xmpcCpalSelObj, "jpxcShow" : that.jpxcShowSelObj, "xmgeBzjcp" : that.xmgeBzjcpSelObj}}
      that.$store.dispatch('company/selCompanyReleaseInfoFormEs', JSON.stringify(param))
        .then(res => {
          if (res.data && res.data.retCode == 1) {
            if(res.data.obj == null || res.data.obj == undefined || res.data.obj.id == null || res.data.obj.id == ""){
              Toast("企业主页未维护，即将返回平台首页");
              setTimeout(that.$router.replace({path: '/home'}),1000)
            }else{
              that.releaseProdCaseList = res.data.otherList;

              if(that.societyId != null && that.societyId != "" && that.societyId != "null" && that.societyId != undefined){
                let retObj = res.data.obj;
                //新增逻辑：如果是通过机构 查看公司详情，需要查这个机构下这个公司的详情信息，内含：星级、职务等信息  这些事基本公司信息中没有的
                retObj.companyInfo = res.data.obj.societyCompany
                // console.log("机构查询出的数据到底是啥"+JSON.stringify(retObj));
                that.companyReleaseInfo = retObj
              }else{
                that.companyReleaseInfo =  res.data.obj
              }
              that.fnFormatCompanyInfo()
               //把企业的名称赋到header的上方commonTopName 中
              // this.$refs.Header.fnSetCommonTopName(this.companyReleaseInfo.companyInfo.companyName)
              // this.$refs.Header.fnSetCommonTopSlogan(this.companyReleaseInfo.companyInfo.companyRemark)
            }
          } else {
            Toast("企业主页未维护，即将返回平台首页");
            setTimeout(that.$router.replace({path: '/home'}),1000)
          }
          // console.log('fnGetCompanyReleaseInfoMain res ===>', res)
        }).catch(err => {
          // console.log('fnGetCompanyReleaseInfoMain err ===>', err)
          Toast("企业主页未维护，即将返回平台首页");
          setTimeout(that.$router.replace({path: '/home'}),1000)
        })
    },
    fnFormatCompanyInfo () {
      this.$nextTick(() => {
        if (this.userInfo != null && this.userInfo.id != null) {
          //并且根据当前登录的userId，查询是否关联过这个企业，如果关联过，
          this.fnSelFollowCompanyByUserId();
        }
        // 已加入协会
        this.fnFormatSocietyName()
        // 关键字
        this.fnFormatKeyWords()
        // 企业特定属性键值对
        // this.fnFormatCompanySpecBos()
        // 主营产品AI报价
        // this.fnInitReleaseProdCaseListAI(true)
        // 其他产品报价
        // this.fnInitReleaseProdCaseListOrther(true)
        // 精品相册 -- 初始化页面时，从this.companyReleaseInfo中取精品相册数据
        // this.fnFormatReleaseBoutiquePhoto();
        // 初始化标准产品
        // this.fnFormatBzcp()
        //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
        this.fnCheckCustInfoByCompanyIdAndUserId();
        //增加企业当前版本的点击数量
        this.fnUpdateHitsNum();
         //增加分辨率计算逻辑
        this.fnCheckShowTopStyle();
      })
    },
    fnFormatSocietyName () {
    // 已加入协会
      this.societyNameArr = []
      this.societyNameArrMore = []
      if (this.companyReleaseInfo.companyInfo.societyNames) {
        let societyNames = this.companyReleaseInfo.companyInfo.societyNames.split(';')
        societyNames.forEach(name => {
          if ("" != name) {
            if (this.societyNameArr.length < 3) {
              this.societyNameArr.push(name)
            } else {
              this.societyNameArrMore.push(name)
            }
          }
        })
      }


    },
    //分辨率计算逻辑
    fnCheckShowTopStyle(){
      let that= this;
      let societyNames = null;
      if(that.companyReleaseInfo.companyInfo.societyNames != null && that.companyReleaseInfo.companyInfo.societyNames != undefined && that.companyReleaseInfo.companyInfo.societyNames != ""){
        societyNames = that.companyReleaseInfo.companyInfo.societyNames.split(';')
      }
      if(societyNames != null && societyNames.length-1 > 0){
        if(societyNames.length-1 == 1){
          if(window.screen.width <= 1367 && that.companyReleaseInfo.companyInfo.companyName.length > 20){
              that.showTopStyle = 2
          }
        }else if(societyNames.length-1 == 2){
          if(window.screen.width <= 1367 && that.companyReleaseInfo.companyInfo.companyName.length > 13){
              that.showTopStyle = 2
          }
        }else if(societyNames.length-1 >= 3){
          if(window.screen.width <= 1367 ){//&& this.companyReleaseInfo.companyInfo.companyName.length > 10
              that.showTopStyle = 2
          }else if(window.screen.width == 1600 && that.companyReleaseInfo.companyInfo.companyName.length > 10){
              that.showTopStyle = 2
          }
        }
      }else{
        that.showTopStyle = 1;
      }
    },
    fnFormatKeyWords () {
      // 关键字
      this.keyWordsArr = []
      if (this.companyReleaseInfo.companyInfo.keywordValue) {
        let keyWords = this.companyReleaseInfo.companyInfo.keywordValue.split(';')
        keyWords.forEach(keyWork => {
          if ("" != keyWork) {
            this.keyWordsArr.push(keyWork)
          }
        })
      }
    },
    fnFormatCompanySpecBos () {
      // 企业特定属性键值对
      this.ccReleaseCompanySpecBos = []
      this.ccReleaseCompanySpecBosMore = []
      if (this.companyReleaseInfo.companyInfo.ccReleaseCompanySpecBoList && this.companyReleaseInfo.companyInfo.ccReleaseCompanySpecBoList.length > 0) {
        this.companyReleaseInfo.companyInfo.ccReleaseCompanySpecBoList.forEach((spec, index) => {
          if (index < 8) {
            this.ccReleaseCompanySpecBos.push(spec)
          } else {
            this.ccReleaseCompanySpecBosMore.push(spec)
          }
        })
      }
    },
    handleBtnProdTypeAIClicked (type) {
      // 主营产品AI报价产品分类点击  1级分类
      // this.prodCaseListAIQueryParam.selSysProdTypeId = null
      this.prodCaseListAIQueryParam.page.pageNum = 0
      this.prodCaseListAIQueryParam.page.total = 0
      // if (type.id != '-1') {
      this.prodCaseListAIQueryParam.selSysProdTypeId = type.id
      this.prodCaseListAIQueryParam.selParentProdTypeId = '-1'
      this.prodCaseListAIQueryParam.selProdTypeId = '-1'
      // }
      // this.fnInitReleaseProdCaseListAI()
    },
    handleSelectedProdTypeAIChanged (value, label, node) {
      this.selectedProdTypeValue = value
      this.selectedProdType = node.triggerNode.$options.propsData.dataRef
    },
    handleBtnProdCaseAISearchClicked () {
      this.prodTypeAI = false
      this.prodCaseListAIQueryParam.selSysProdTypeId = '-1'
      this.prodCaseListAIQueryParam.selParentProdTypeId = '-1'
      this.prodCaseListAIQueryParam.selProdTypeId = '-1'
      if (this.selectedProdType.id != '-1') {
        this.prodCaseListAIQueryParam.selSysProdTypeId = this.selectedProdType.rootId
        if (this.selectedProdType.pid == this.selectedProdType.rootId) {
          this.prodCaseListAIQueryParam.selParentProdTypeId = this.selectedProdType.id
        } else {
          this.prodCaseListAIQueryParam.selParentProdTypeId = this.selectedProdType.pid
          this.prodCaseListAIQueryParam.selProdTypeId = this.selectedProdType.id
        }
      }

      this.prodCaseListAIQueryParam.page.pageNum = 0
      this.prodCaseListAIQueryParam.page.total = 0
      // this.fnInitReleaseProdCaseListAI()
    },
    handleBtnProdCaseAIResetClicked () {
      this.prodTypeAI = false
      this.selectedProdTypeValue = '-1'
      this.selectedProdType = {id: '-1'}
      this.prodCaseListAIQueryParam = {
        companyId: null,
        selSysProdTypeId: '-1',
        selParentProdTypeId: null,
        selProdTypeId: null,
        quotedPriceType: 1,
        searchStr: '',
        page: {
          pageNum: 0,
          pageSize: 6,
          taotal: 0
        }
      }
      // this.fnInitReleaseProdCaseListAI()
    },
    handleProdCaseAIPageChange (page, pageSize) {
      this.prodCaseListAIQueryParam.page.pageNum = page - 1
      this.prodCaseListAIQueryParam.page.pageSize = pageSize
      // this.fnInitReleaseProdCaseListAI()
    },
    // fnInitReleaseProdCaseListAI (init) {
    //   this.releaseProdCaseListAI = []
    //   this.prodCaseListAIQueryParam.companyId = this.companyReleaseInfo.companyId
    //   this.$store.dispatch('company/selReleaseProdCasePageFormEs', JSON.stringify(this.prodCaseListAIQueryParam))
    //     .then(res => {
    //       console.log('fnInitReleaseProdCaseListAI res ===>', res)
    //       if (res.data.obj && res.data.obj.releaseProdCaseList) {
    //         let page = res.data.obj.page
    //         this.prodCaseListAIQueryParam.page.total = page.total
    //         this.releaseProdCaseListAI = [...res.data.obj.releaseProdCaseList]
    //         if (init) {
    //           this.showAi = page.total > 0
    //         }
    //       }

    //     }).catch(err => {
    //       console.log('fnInitReleaseProdCaseListAI err ===>', err)
    //     })
    // },
    handleBtnProdTypeOrtherClicked (type) {
      // 主营产品AI报价产品分类点击  1级分类
      // this.prodCaseListOrtherQueryParam.selSysProdTypeId = null
      this.prodCaseListOrtherQueryParam.page.pageNum = 0
      this.prodCaseListOrtherQueryParam.page.total = 0
      // if (type.id != '-1') {
      this.prodCaseListOrtherQueryParam.selSysProdTypeId = type.id
      this.prodCaseListOrtherQueryParam.selParentProdTypeId = '-1'
      this.prodCaseListOrtherQueryParam.selProdTypeId = '-1'
      // }
      // this.fnInitReleaseProdCaseListOrther()
    },
    handleBtnProdTypeOrtherChanged (value, label, node) {
      this.selectedProdTypeValueOrther = value
      this.selectedProdTypeOrther = node.triggerNode.$options.propsData.dataRef
    },
    handleBtnProdCaseOrtherSearchClicked () {
      this.prodTypeOther = false
      this.prodCaseListOrtherQueryParam.selSysProdTypeId = '-1'
      this.prodCaseListOrtherQueryParam.selParentProdTypeId = '-1'
      this.prodCaseListOrtherQueryParam.selProdTypeId = '-1'
      if (this.selectedProdTypeOrther.id != '-1') {
        this.prodCaseListOrtherQueryParam.selSysProdTypeId = this.selectedProdTypeOrther.rootId
        if (this.selectedProdTypeOrther.pid == this.selectedProdTypeOrther.rootId) {
          this.prodCaseListOrtherQueryParam.selParentProdTypeId = this.selectedProdTypeOrther.id
        } else {
          this.prodCaseListOrtherQueryParam.selParentProdTypeId = this.selectedProdTypeOrther.pid
          this.prodCaseListOrtherQueryParam.selProdTypeId = this.selectedProdTypeOrther.id
        }
      }

      this.prodCaseListOrtherQueryParam.page.pageNum = 0
      this.prodCaseListOrtherQueryParam.page.total = 0
      // this.fnInitReleaseProdCaseListOrther()
    },
    handleBtnProdCaseOrtherResetClicked () {
      this.prodTypeOther = false
      this.selectedProdTypeValueOrther = '-1'
      this.selectedProdTypeOrther = {id: '-1'}
      this.prodCaseListOrtherQueryParam = {
        companyId: null,
        selSysProdTypeId: '-1',
        selParentProdTypeId: null,
        selProdTypeId: null,
        quotedPriceType: 2,
        searchStr: '',
        page: {
          pageNum: 0,
          pageSize: 6,
          total: 0
        }
      }
      // this.fnInitReleaseProdCaseListOrther()
    },
    handleProdCaseOrtherPageChange (page, pageSize) {
      this.prodCaseListOrtherQueryParam.page.pageNum = page - 1
      this.prodCaseListOrtherQueryParam.page.pageSize = pageSize
      // this.fnInitReleaseProdCaseListOrther()
    },
    // fnInitReleaseProdCaseListOrther (init) {
    //   this.releaseProdCaseListOrther = []
    //   this.prodCaseListOrtherQueryParam.companyId = this.companyReleaseInfo.companyId
    //   console.log('this.prodCaseListOrtherQueryParam ===>', this.prodCaseListOrtherQueryParam)
    //   this.$store.dispatch('company/selReleaseProdCasePageFormEs', JSON.stringify(this.prodCaseListOrtherQueryParam))
    //     .then(res => {
    //       console.log('fnInitReleaseProdCaseListOrther res ===>', res)
    //       if (res.data.obj && res.data.obj.releaseProdCaseList) {
    //         let page = res.data.obj.page
    //         this.prodCaseListOrtherQueryParam.page.total = page.total
    //         res.data.obj.releaseProdCaseList.forEach(caseInfo => {
    //           caseInfo.showTelPop = false
    //         })
    //         this.releaseProdCaseListOrther = [...res.data.obj.releaseProdCaseList]
    //         if (init) {
    //           this.showOrther = page.total > 0
    //         }
    //       }
    //     }).catch(err => {
    //       console.log('fnInitReleaseProdCaseListOrther err ===>', err)
    //     })
    // },
    fnFormatReleaseBoutiquePhoto () {
      // 初始化页面时   初始化精品相册信息
      this.releaseBoutiquePhotoList = []
      this.releaseBoutiquePhotoTypeList = []
      if (this.companyReleaseInfo.companyReleaseDetail.jpxcShow) {
        if (this.companyReleaseInfo.companyReleaseDetail.jpxcShow.releaseBoutiquePhotoList) {
          this.releaseBoutiquePhotoList = [...this.companyReleaseInfo.companyReleaseDetail.jpxcShow.releaseBoutiquePhotoList]
        }
        if (this.companyReleaseInfo.companyReleaseDetail.jpxcShow.releaseBoutiquePhotoTypeList) {
          this.releaseBoutiquePhotoTypeList = [...this.companyReleaseInfo.companyReleaseDetail.jpxcShow.releaseBoutiquePhotoTypeList]
        }
        if (this.companyReleaseInfo.companyReleaseDetail.jpxcShow.page) {
          this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.page = this.companyReleaseInfo.companyReleaseDetail.jpxcShow.page
          this.showJpxc = this.companyReleaseInfo.companyReleaseDetail.jpxcShow.page.total > 0
        }
      }
    },
    fnFormatBzcp () {
      if (this.companyReleaseInfo.companyReleaseDetail && this.companyReleaseInfo.companyReleaseDetail.xmgeBzjcp) {
        this.prodInfoListBzcp = [...this.companyReleaseInfo.companyReleaseDetail.xmgeBzjcp.prodInfoList]
        if (this.companyReleaseInfo.companyReleaseDetail.xmgeBzjcp.page) {
          this.prodCaseListBzcpQueryParam.page = this.companyReleaseInfo.companyReleaseDetail.xmgeBzjcp.page
          this.showBzcp = this.prodCaseListBzcpQueryParam.page.total > 0
        } else {
          this.prodCaseListBzcpQueryParam.page.pageNum = 1
          this.prodCaseListBzcpQueryParam.page.total = this.prodInfoListBzcp.length
        }
      }
    },
    handleProdCaseBzcpPageChange (page, pageSize) {
      this.prodCaseListBzcpQueryParam.page.pageNum = page - 1
      this.prodCaseListBzcpQueryParam.page.pageSize = pageSize
      this.fnInitReleaseProdCaseListBzcp()
    },
    handleBtnProdTypeBzcpClicked (type) {
      // 标准产品 产品分类点击事件
      this.prodCaseListBzcpQueryParam.page.pageNum = 0
      this.prodCaseListBzcpQueryParam.page.total = 0
      this.prodCaseListBzcpQueryParam.sysProdTypeId = type.id
      this.fnInitReleaseProdCaseListBzcp()
    },
    fnInitReleaseProdCaseListBzcp () {
      this.prodInfoListBzcp = []
      this.prodCaseListBzcpQueryParam.companyId = this.companyReleaseInfo.companyId
      this.$store.dispatch('company/selProdInfoPageFormEs', JSON.stringify(this.prodCaseListBzcpQueryParam))
        .then(res => {
          // console.log('fnInitReleaseProdCaseListBzcp res ===>', res)
          this.prodInfoListBzcp = [...res.data.objs];
          if (res.data.page) {
            this.prodCaseListBzcpQueryParam.page = res.data.page
          } else {
            this.prodCaseListBzcpQueryParam.page.pageNum = 1
            this.prodCaseListBzcpQueryParam.page.total = this.prodInfoListBzcp.length
          }
        }).catch(err => {
          console.log('handleBtnProdTypeBzcpClicked err ===>', err)
        })
    },
    handleBtnReleaseBoutiquePhotoTypeClicked (type) {
      // 点击精品相册分类时调用方法
      this.releaseBoutiquePhotoParam.classifyId = type
      if (type != '全部') {
        this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.classifyId = type
      } else {
        this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.classifyId = null
      }
      this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.page.pageNum = 0
      this.fnInitReleaseBoutiquePhoto()
    },
    handleReleaseBoutiquePhotoPageChange (page, pageSize) {
      this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.page.pageNum = page - 1
      this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.page.pageSize = pageSize
      this.fnInitReleaseBoutiquePhoto()
    },
    fnInitReleaseBoutiquePhoto () {
      this.releaseBoutiquePhotoList = []
      this.releaseBoutiquePhotoParam.companyId = this.companyReleaseInfo.companyId
      this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.companyId = this.companyReleaseInfo.companyId
      this.$store.dispatch('company/selReleaseBoutiquePhotoPage', JSON.stringify(this.releaseBoutiquePhotoParam))
        .then(res => {
          console.log('fnInitReleaseBoutiquePhoto res ===>', res)
          if (res.data.obj && res.data.obj.releaseBoutiquePhotoList) {
            let page = res.data.obj.page;
            this.releaseBoutiquePhotoParam.companyReleaseDetail.jpxcShow.page.total = page.total
            this.releaseBoutiquePhotoList = [...res.data.obj.releaseBoutiquePhotoList]
          }
        }).catch(err => {

        })
    },
    fnGetChildrenProdType (prodType, twoProdTypeList, threeProdTypeList) {
      let children = []
      children = twoProdTypeList.filter(child => {
        if (child.pid == prodType.id) {
          child.label = child.name
          child.value = child.id
          child.footerId = prodType.footerId
          if (threeProdTypeList && threeProdTypeList.length > 0) {
            child.children = this.fnGetChildrenProdType(child, threeProdTypeList)
          }
          return true
        }
        return false
      })
      return children
    },
    handleMoreAssociationChanged () {
      this.showMoreAssociation = !this.showMoreAssociation
    },
    handleProdTypeAIChanged () {
      this.prodTypeAI = !this.prodTypeAI
      this.prodTypeOther = false
    },
    handleProdTypeOtherChanged () {
      this.prodTypeOther = !this.prodTypeOther
      this.prodTypeAI = false
      // console.log('this.prodTypeOther===>', this.prodTypeOther)
    },
    handleOpenClose (open) {
      this.baseOpen = open
    },
    showSearch () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop  > this.scrollRange) {
        this.toTop = true;
      }else {
        this.toTop = false;
      }
      // 判断锚点
      this.fnHandleChangeTap()
    },
    fnHandleChangeTap () {
      let a = this.$refs.a
      let a2 = this.$refs.a2
      let a3 = this.$refs.a3
      let a4 = this.$refs.a4
      let a5 = this.$refs.a5
      let a6 = this.$refs.a6
      if (a5 && a5.getBoundingClientRect().top) {
        if (a5.getBoundingClientRect().top <= 600) {
          this.tab = 5
          return
        }
      }
      if (a4 && a4.getBoundingClientRect().top) {
        if (a4.getBoundingClientRect().top <= 600) {
          this.tab = 4
          return
        }
      }
      if (a6 && a6.getBoundingClientRect().top) {
        if (a6.getBoundingClientRect().top <= 600) {
            this.tab = 6
            return
        }
      }
      if (a3 && a3.getBoundingClientRect().top) {
        if (a3.getBoundingClientRect().top <= 600) {
          this.tab = 3
          return
        }
      }
      if (a && a.getBoundingClientRect().top) {
        if (a.getBoundingClientRect().top <= 600) {
          this.tab = 1
          return
        }
      }
      if (a2 && a2.getBoundingClientRect().top) {
        if (a2.getBoundingClientRect().top <= 600) {
          this.tab = 2
          return
        }
      }
    },
    handlePageClicked () {
      this.showMoreAssociation = false
      this.prodTypeAI = false
      this.prodTypeOther = false
      this.showTelPop = false
      // if (this.releaseProdCaseListOrther && this.releaseProdCaseListOrther.length > 0) {
      //   this.releaseProdCaseListOrther.forEach(caseInfo => {
      //     caseInfo.showTelPop = false
      //   })
      // }
    },
    fnGetSpanStyle () {
      let style = 'width: 334px;padding-top: 3px; padding-bottom: 3px;white-space: nowrap;'
      return style
    },
    fnEncodeCompanyPhone (phone) {
      if (phone) {
        return phone.substring(0, 3) + "****" + phone.substring(phone.length - 4, phone.length)
      } else {
        return ''
      }
    },
    handleBtnLoginClick () {
      this.$refs.quoLoginModule.showLogin()
    },
    handleLognSucccess (userInfo) {
      // this.$router.go(0)
      this.userInfo = userInfo
      this.$refs.Header.fnSetUserInfo(this.userInfo)
      //判断当前用户是否已登录
      this.fnSelFollowCompanyByUserId();
    },
    //关注该企业：必须先登录   type  0关注  1取消关注
    fnGotoFollowCompany(type,e){
      if(e != null && e != undefined){
        this.fnStopBub(e);
      }
      if(this.userInfo != null && this.userInfo.id != null){
       //如果登录了，直接保存关注信息 、 取消关注信息
        let obj = new Object();
        obj.userId = this.userInfo.id;
        obj.companyId = this.companyId;
        obj.optType = type;
        obj.ccReleaseVersionId = this.companyReleaseInfo.id;//关注的版本id
        obj.id = (this.ucFollowCompany != null && this.ucFollowCompany.id != null && this.ucFollowCompany.id != undefined && this.ucFollowCompany.id != "") ? this.ucFollowCompany.id : null;
        this.$store.dispatch('company/saveOrDelUcFollowCompany', JSON.stringify(obj))
          .then((res)=>{
            Toast(res.data.retMsg);
            if(type == 0){
              this.isFollow = 1;
              this.ucFollowCompany = res.data.obj;
            }else{
              this.isFollow = 0;
              this.ucFollowCompany = null;
            }
          })
      }else{
        let optType = 2;//2关注  3取消关注
        if(type == 0){
          optType = 2;//2关注  3取消关注
        }else{
          optType = 3;//2关注  3取消关注
        }
        this.$refs.quoLoginModule.showLogin()
      }
    },
    //根据当前登录的用户id查询是否已经关注了该企业
    fnSelFollowCompanyByUserId(){
      if(this.userInfo.id != null && this.userInfo.id != undefined && this.userInfo.id != ""){
        let obj = new Object();
        obj.userId = this.userInfo.id;
        obj.companyId = this.companyId;

        this.$store.dispatch('company/selByUserIdAndCompanyId', JSON.stringify(obj))
          .then((res)=>{
            this.ucFollowCompany = res.data.obj;
            if(res.data.obj != null && res.data.obj != undefined){
              this.isFollow = 1;
            }else{
              this.isFollow = 0;
            }
            //最后根据查询结果，看看是否直接执行关注。可能之前已经关注过了，就直接给提示即可
            var optType = this.$route.query.optType;
            if(this.ucFollowCompany == null && optType != null && optType != undefined && this.isFollow == 0){
              if(optType == 2){
                this.fnGotoFollowCompany(0,null);
              }
            }else if(optType != null && optType != undefined){
              Toast("已关注过该企业");
            }
        })
      }else{
        this.isFollow = 0;
      }
    },
    //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
    fnCheckCustInfoByCompanyIdAndUserId(ccProjectInfoBo){
      if(this.userInfo.id != null && this.userInfo.id != undefined && this.userInfo.id != ""){
        let obj = new Object();
        obj.userId = this.userInfo.id;
        obj.companyId = this.companyId;
        if (ccProjectInfoBo) {
          obj.inTypeText = "案例'" + ccProjectInfoBo.name + "'进入";//进入方式文本描述，存到客户备注中： ***案例进入；
        } else {
          obj.inTypeText = "企业主页进入";//进入方式文本描述，存到客户备注中： ***案例进入；
        }
        this.$store.dispatch('company/queryByUserIdAndCompanyId', JSON.stringify(obj))
          .then((res)=>{
            // alert(1);
          })
      }else{
        this.isFollow = 0;
      }
    },
    //跳转到平台首页
    fnGoToHomePage(e){
       this.fnStopBub(e);
       this.$router.push({path: '/home'});
    },
    //跳转到机构主页
    fnGoToSocietyIndexPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/societyIndex', query:  {societyId:this.societyId,societyName:this.societyName,logoImgUrl:this.logoImgUrl}});
    },

    //跳转到找合作  搜索页直接查 2企业  、  1 产品
    fnGotoSearchPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/search', query: {selType:2}});
    },
    fnGotoCaseSearchPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/caseSearch', query: {selType:1}});
    },
    //跳转到需求查询页
    fnGotoDemandPage(e){
      this.fnStopBub(e);
       this.$router.push({path: '/demand', query: {selType:2}});
    },
    //跳转到案例详情页
    fnGotoCaseDetail (id, e) {
      this.fnStopBub(e);
      this.$router.push({path: '/caseDetail', query: {projectId:id,inType:0}});
    },
    fnGotoAiznbjPage (caseInfo) {
      this.$store.dispatch('company/getProjectInfoById', JSON.stringify(caseInfo))
        .then((res)=>{
          var ccProjectInfoBo = res.data.obj;
          var schemeInfo = {
            saasProjectId: ccProjectInfoBo.saasProjectId, // 对应saas的方案id
            saasFactoryId: ccProjectInfoBo.saasFactoryId,// 对应saas的工厂id
            projectId: ccProjectInfoBo.id,// 平台方案id
            ccProdTypeId: ccProjectInfoBo.ccProdTypeId,//分类id
            ccProdTypeName: ccProjectInfoBo.prodTypeName,//分类name
            projectName: ccProjectInfoBo.name,
            companyName: ccProjectInfoBo.companyName,
            companyId: ccProjectInfoBo.companyId
          }
          // console.log('fnGotoAiznbjPage schemeInfo===>', schemeInfo)
          localStorage.setItem("schemeInfo", JSON.stringify(schemeInfo));
          this.$router.push({path: '/cdrConvert', name: 'AI报价', params: {'schemeInfo': JSON.stringify(schemeInfo)}});
          //根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息，生成了不做处理，未生成，创建游客
          this.fnCheckCustInfoByCompanyIdAndUserId(ccProjectInfoBo);
        })
    },
    showTel (e) {
      // console.log('showTel this.showTelPop===>', this.showTelPop)
      this.showTelPop = !this.showTelPop
    },
    showCaseInfoTel (e, caseInfo) {
      if (caseInfo.showTelPop) {
        caseInfo.showTelPop = false
      } else {
        // if (this.releaseProdCaseListOrther && this.releaseProdCaseListOrther.length > 0) {
        //   this.releaseProdCaseListOrther.forEach(caseInfo => {
        //     caseInfo.showTelPop = false
        //   })
        // }
        caseInfo.showTelPop = true
      }
    },
    handleBtnBannerLeftClicked () {
     this.swiper.slidePrev()
    },
    handleBtnBannerRightClicked () {
     this.swiper.slideNext()
    },
    handleBtnTabClicked (t) {
      this.tab = t
    },
    //更新当前版本的点击次数
    fnUpdateHitsNum(){
      let obj = new Object();
      obj.hitsNum = 1;
      obj.id = this.companyReleaseInfo.id;//版本id;
      obj.companyId = this.companyReleaseInfo.companyId;
      requestByPost(API.fnUpdateHitsNum,JSON.stringify(obj)).then((res)=>{
        // alert(1);
      })
    },
    //协会的...光标获取后触发
    mouseOver(societyNames){
      if(societyNames != null && societyNames != "" && societyNames != undefined && societyNames != "null" && societyNames != "undefined"){
        let lastList = [];
        let societyNamesList = societyNames.split(";");
        $(societyNamesList).each(function(i,value){
          if(value != null && value != ""){
            lastList[lastList.length] = value;
          }
        });
        this.societyList = lastList//当前要浮层显示的公司的机构名称数组
      }else{
        this.societyList = [];
      }
    },
    getEchartData(obj) {
      let myChart = this.$echarts.init(document.getElementById(obj.id))
      var dataname = obj.name
      var datamax = obj.arr
      var datavaule = obj.arr1
      var datavauleS =  obj.arr2
      var datavauleD =  obj.arr3
      var indicator = []
      for (var i = 0; i < dataname.length; i++) {
        indicator.push({
          name: dataname[i],
          max: datamax[i],
        })
      }
      function contains(arrays, obj) {
        var i = arrays.length;
        while (i--) {
          if (arrays[i] === obj) {
            return i;
          }
        }
        return false;
      }
      let  option = {
        tooltip: {
          show: false,
          trigger: "item",
          formatter:function(params){
            return params.value
          }
        },
        radar: [
          {
            center: ["50%", "50%"],
            radius: "65%",
            startAngle: 240,
            splitNumber: 5,
            splitArea: {
              areaStyle: {
                "color": [
                  "#0100bd",
                  "#3434ca",
                  "#5d5cd4"
                ]
              }
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "transparent"
              }
            },
            name: {
              formatter: function (value) {
                var i = contains(dataname, value);
                var percent = datavaule[i];
                var ret = "";
                var maxLength = 4;
                var valLength = value.length;
                var rowN = Math.ceil(valLength / maxLength);
                if (rowN > 1) {
                  var temp = "";
                  var start = 0;
                  var end = maxLength;
                  temp = value.substring(start, end)+'\n'+value.substring(end, valLength)
                  ret += temp;
                  return '{a|' + percent + '}\n' + '{b|' + ret + '}'
                } else {
                  return '{a|' + percent + '}\n' + '{b|' + value + '}'
                }
              },
              textStyle: {
                rich: {
                  a: {
                    color: '#FFFFFF',
                    fontSize: 15,
                    padding: [0, 0],
                    lineHeight:20,
                  },
                  b: {
                    color: '#394291',
                    fontSize: 15,
                    padding: [0, 6],
                    lineHeight:20,
                  }
                },
              },
            },
            indicator: indicator
          }
        ],
        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 7,
            areaStyle: {
              normal: {
                color: 'rgba(170, 216, 255, 0)',
              }
            },
            itemStyle: {
              color: '#eddf00',
              borderColor: '#eddf00',
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                color: "#eddf00",
                width: 1
              }
            },
            data: [datavaule]
          },
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 7,
            areaStyle: {
              normal: {
                color: 'rgba(170, 216, 255, 0)',
              }
            },
            itemStyle: {
              color: '#e3a164',
              borderColor: '#e3a164',
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                color: "#e3a164",
                width: 1,
                type: "dashed"
              }
            },
            data: [datavauleS]
          },
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 7,
            areaStyle: {
              normal: {
                color: 'rgba(170, 216, 255, 0)',
              }
            },
            itemStyle: {
              color: '#8ec31d',
              borderColor: '#8ec31d',
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                color: "#8ec31d",
                width: 1,
                type: "dashed"
              }
            },
            data: [datavauleD]
          }
        ]
      }
      myChart.setOption(option);
    },
    getEchartDataTwo(obj) {
      let myChart = this.$echarts.init(document.getElementById(obj.id))
      var dataname = obj.name
      var datamax = obj.arr
      var datavaule = obj.arr1
      var datavauleS =  obj.arr2
      var datavauleD =  obj.arr3
      var indicator = []
      for (var i = 0; i < dataname.length; i++) {
        indicator.push({
          name: dataname[i],
          max: datamax[i],
        })
      }
      function contains(arrays, obj) {
        var i = arrays.length;
        while (i--) {
          if (arrays[i] === obj) {
            return i;
          }
        }
        return false;
      }
      let option = {
        tooltip: {
          show:false,
          trigger: 'item',
          formatter:function(params){
            return params.value
          }
        },
        radar: [
          {
            center: ["50%", "50%"],
            radius: "65%",
            startAngle: 240,
            splitNumber: 5,
            splitArea: {
              areaStyle: {
                "color": [
                  "#0100bd",
                  "#3434ca",
                  "#5d5cd4"
                ]
              }
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "transparent"
              }
            },
            name: {
              formatter:function(value){
                var i = contains(dataname, value);
                var percent = datavaule[i];
                var ret = "";
                var maxLength = 4;
                var valLength = value.length;
                var rowN = Math.ceil(valLength / maxLength);
                if (rowN > 1) {
                  var temp = "";
                  var start = 0;
                  var end = maxLength;
                  temp = value.substring(start, end)+'\n'+value.substring(end, valLength)
                  ret += temp;
                  return '{a|' + percent + '}\n' + '{b|' + ret + '}'
                } else {
                  return '{a|' + percent + '}\n' + '{b|' + value + '}'
                }
              },
              textStyle: {
                rich: {
                  a: {
                    color: '#FFFFFF',
                    fontSize: 15,
                    padding: [0, 0],
                    lineHeight:20,
                  },
                  b: {
                    color: '#394291',
                    fontSize: 15,
                    padding: [0, 0],
                    lineHeight:20,
                  }
                },
              },
            },
            indicator: indicator
          }
        ],
        series: [
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 7,
            areaStyle: {
              normal: {
                color: 'rgba(170, 216, 255, 0)',
              }
            },
            itemStyle: {
              color: '#eddf00',
              borderColor: '#eddf00',
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                color: "#eddf00",
                width: 1
              }
            },
            data: [datavaule]
          },
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 7,
            areaStyle: {
              normal: {
                color: 'rgba(170, 216, 255, 0)',
              }
            },
            itemStyle: {
              color: '#e3a164',
              borderColor: '#e3a164',
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                color: "#e3a164",
                width: 1,
                type: "dashed"
              }
            },
            data: [datavauleS]
          },
          {
            type: "radar",
            symbol: "circle",
            symbolSize: 7,
            areaStyle: {
              normal: {
                color: 'rgba(170, 216, 255, 0)',
              }
            },
            itemStyle: {
              color: '#8ec31d',
              borderColor: '#8ec31d',
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                color: "#8ec31d",
                width: 1,
                type: "dashed"
              }
            },
            data: [datavauleD]
          }
        ]
      };
      myChart.setOption(option);
    },
    //点击关闭案例放大弹出层
    fnHideBigShow(e){
      this.showfix = false;
      this.fnStopBub(e);
    },
    //点击上一个，下一个。切换案例放大弹出层
    fnGotoNextCompanyDetail(num,e){
      this.fnStopBub(e);
      // nowReleaseProdCase:null,//当前点击放大的案例对象
      if(this.nowIndex == 0 && num == -1){//当前点击放大的案例下标
         Toast('当前已是第一个案例')
      }else if(this.nowIndex == (this.releaseProdCaseList.length-1) && num == 1){//当前点击放大的案例下标
         Toast('当前已是最后一个案例')
      }else{
        this.nowIndex =this.nowIndex + num;
        this.nowReleaseProdCase = this.releaseProdCaseList[this.nowIndex];
      }

    },
     //点击打开案例放大弹出层
    fnOpenBigShow(releaseProdCase,index,e){
      this.showfix = true;
      this.fnStopBub(e);
      this.nowReleaseProdCase = releaseProdCase;//当前点击放大的案例对象
      this.nowIndex = index;//当前点击放大的案例下标
    },
  },
  mounted(){
    // this.inEc()
    // let obj = {
    //   id:"myChart",
    //   name:['综合产值规模评分' ,'人员结构管理评分' ,'物流管理能力评分' ,'业务资金健康评分' ,'生产管理能力评分'],
    //   arr:[30, 30, 30, 30, 30,30],
    //   arr1:[10, 16, 20, 15, 12,18],
    //   arr2:[5, 2, 10, 10, 10,15],
    //   arr3:[15, 22, 20, 20, 20,15]
    // }
    // let obj2 = {
    //   id:"myChart2",
    //   name:['平台订单交付时长评分' ,'客户服务能力评分' ,'平台企业受关注度' ,'平台售后服务质量评分' ,'平台服务区域范围评分' ,'平台产品方案热度'],
    //   arr:[30, 30, 30, 30, 30,30],
    //   arr1:[10, 16, 20, 15, 12,18],
    //   arr2:[5, 2, 10, 10, 10,15],
    //   arr3:[15, 22, 20, 20, 20,15]
    // }
    // let obj3 = {
    //   id:"myChartLine",
    //   name:['1K以下','1~2K','2~3K','3~5K','5~10K','10~20K','20~30K','30~40K','40K以上'],
    //   arr:[502.84, 205.97, 332.79, 281.55, 398.35, 214.02, 45,89,245],
    //   arr2:[181.55, 298.35, 314.02, 279.55, 189.57, 256.14,114.02, 45,89,245],
    //   arr3:[281.55, 398.35, 214.02, 179.55, 289.57, 356.14,214.02, 45,89,245]
    // }
    // this.getEchartData(obj);
    // this.getEchartDataline(obj3)
    // this.getEchartDataTwo(obj2)
    window.addEventListener("scroll", this.showSearch)

  },
  created(){
    this.$store.commit('home/setMenuActive', -1);
     // this.fnStopBub();
    //  this.checkDetailTitle = params;
    if (this.$route.query && this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId
      this.$nextTick(() => {
        this.fnGetCompanyReleaseInfoMain()
        this.fnInitProdType()
      })
    } else {
      Toast("企业主页未维护，即将返回平台首页");
      setTimeout(this.$router.replace({path: '/home'}),1000)
    }
  },
  //
  updated(){
    //每个图片加载完都
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/companyDetailNew.vue